<template>
  <div class="loading-layout">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </div>
</template>

<script>
import AuthService from '../utils/msal';

export default {
  name: 'Login',
  components: {},

  mounted() {
    if (!this.$AuthService.isLogIn()) {
      this.$AuthService.login();
    } else {
      this.$router.push('/');
    }
  },
};
</script>

<style></style>
